import { render, staticRenderFns } from "./dashboard-index.vue?vue&type=template&id=e9a4a51c"
import script from "./dashboard-index.vue?vue&type=script&lang=js"
export * from "./dashboard-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports